export default "__VITE_ASSET__BaEYiUCc__"